<template>
    <div id="app">
        <router-view/>
        <Login></Login>
        <ZoomHint></ZoomHint>
        <DestAirlineSearch></DestAirlineSearch>
    </div>
</template>

<script>
    import Login from '@/components/Login.vue';
    import ZoomHint from '@/components/plugin/ZoomHint.vue';
    import DestAirlineSearch from '@/components/plugin/DestAirlineSearch.vue';

    export default {
        components: {
            Login,
            ZoomHint,
            DestAirlineSearch
        },
        computed: {
            // 判断登录Ajax是否完成
            loginAjaxComplete() {
                return this.$store.state.Login.loginAjaxComplete;
            },
            // 登录数据
            loginData() {
                return this.$store.state.Login.loginData;
            }
        },
        watch: {
            // 判断登录Ajax是否完成
            loginAjaxComplete() {
                // 网易七鱼初始化
                this.ysfInit();
            }
        },
        created() {
            this.$isLogin();// 获取登录状态
            this.heartConnectionFn();// oracle心跳Fn
            // 网易七鱼初始化
            this.ysfInit();
            // IE10 提醒升级浏览器
            this.IE10();
            // this.askPriceNotify();
        },
        methods: {
            // IE10 提醒升级浏览器
            IE10() {
                if (!window.navigator.userAgent.includes('MSIE 10')) {
                    return;
                }
                const h = this.$createElement;
                this.$notify({
                    title: '浏览器升级提醒',
                    message: h(
                        'div', {
                            style: 'width:97%;max-width:268px'
                        }, [
                            h('span', 'hi，您当前的浏览器版本过低，可能存在安全风险，建议升级浏览器：'),
                            h('div', {
                                style: 'text-align:right;',
                            }, [
                                h('el-button', {
                                    style: 'margin-top: 10px',
                                    on: {
                                        click: () => {
                                            window.location.href = 'https://www.google.cn/chrome/';
                                        },
                                    },
                                }, [
                                    h('i', {class: ['iconfont', 'icon-chrome']}, ''),
                                    h('span', {style: 'margin-left:4px'}, 'chrome'),
                                ]),
                                h('el-button', {
                                    style: 'margin-top: 10px',
                                    on: {
                                        click: () => {
                                            window.location.href = 'https://browser.360.cn/ee/';
                                        }
                                    },
                                }, [
                                    h('i', {class: ['iconfont', 'icon-chrome1']}, ''),
                                    h('span', {style: 'margin-left:4px'}, '360极速浏览器'),
                                ]),

                            ]),
                        ]
                    ),
                    position: 'bottom-left',
                    duration: 0,
                    type: 'warning'
                });
            },
            // oracle心跳Fn
            heartConnectionFn() {
                let intervalTimer = 60000;// 60秒
                this.sendHeartFn();// 发送心跳Fn
                setInterval(() => {
                    // 获取上一次心跳时间
                    let oldHeartTime = sessionStorage.heartTime || 0;
                    // 获取新的心跳时间
                    let newHeartTime = +new Date();
                    // 节流算法
                    if (newHeartTime - oldHeartTime >= intervalTimer) {
                        this.sendHeartFn();// 发送心跳Fn
                    }
                }, parseInt(intervalTimer + 1000));
            },
            // 发送心跳Fn
            sendHeartFn() {
                // 发送
                this.$ajax({
                    url: '/personalCenterHandler/common/PersonalCenterCommonHandler.ashx',
                    bigData: false,
                    errHandler: false,
                    data: {
                        act: 'heartConnection'// 心跳连接
                    }
                });
                // 更新最新的心跳时间
                sessionStorage.heartTime = new Date().getTime();
            },
            // 网易七鱼初始化
            ysfInit() {
                // // 如果未获取到登录状态
                // if (!this.loginAjaxComplete) {
                //    return;
                // }
                // this.$ysf('onready', () => {
                //    // 网易七鱼加载完毕
                //    this.$store.commit('ysfOnReady', true);
                // });
            },
            // askPriceNotify() {
            //     const h = this.$createElement;
            //    
            //    
            //     this.$ajax({
            //         url: '/AskPriceHandler/AskPriceHandler.ashx',
            //         data: {
            //             act: 'getAskPriceMessageData',// 获取询价消息的数据
            //         },
            //         success: (res) => {
            //             let messageList = res.success.messageList;
            //         }
            //     });
            //    
            //    
            //    
            //     // this.$setInterval(() => {
            //     let _this = this.$notify({
            //         duration: 0,
            //         customClass: 'askPriceGlobalNotifyCSS',
            //         message: h('div', {
            //             style: 'font-size: 12px;color: #4D4D4D;',
            //         }, [
            //             h('div', '您的询价：'),
            //             h('div', {
            //                 style: 'display: flex;align-items: center;margin-top: 8px;'
            //             }, [
            //                 h('span', {style: 'white-space: nowrap'}, '2月21日  PVG-AMS，1件 100公斤 1立方  有新回复'),
            //                 h('span', {
            //                     style: 'text-decoration: underline;font-weight: 700;margin-left: 10px;white-space: nowrap;cursor: pointer;',
            //                     on: {
            //                         click: () => this.onAskPriceNotifyClick(_this)
            //                     }
            //                 }, '查看')
            //             ])
            //         ])
            //     });
            //     // },5000);
            // },
            // onAskPriceNotifyClick(_this) {
            //     let path = this.$router.resolve({
            //         path: 'product/askPrice',
            //         query: {askId: '39'}
            //     });
            //     _this.close();
            //     window.open(path.href,'_blank');
            // }
        }
    };
</script>
<style lang="scss">
    .khang.el-popover {
        color: #fff;
        background: rgba(0, 0, 0, 0.7);
    }

    .khang.el-popper[x-placement^=left] .popper__arrow::after {
        border-left-color: rgba(0, 0, 0, 0.7);
    }
    //
    //.askPriceGlobalNotifyCSS{
    //    width: auto !important;
    //}

</style>
